import { Routes, Route } from "react-router-dom";
import Navbar from "./../components/NavBar/NavBar";
import Footer from "./../components/Footer";
import Home from "./../pages/Home";
import About from "./../pages/About";
import Contact from "./../pages/Contact";
import Portfolio from "./../pages/Portfolio";
import Products from "./../pages/Products";
import Windows from "./../pages/Products/Windows";
import EntranceDoors from "./../pages/Products/EntranceDoors";
import InteriorDoors from "./../pages/Products/InteriorDoors";
import SlidingDoors from "./../pages/Products/SlidingDoors";
import WinterGarden from "./../pages/Products/WinterGarden";
import Wooden from "./../pages/Products/WindowTypes/Wooden";
import Passive from "./../pages/Products/WindowTypes/Passive";
import WoodAlu from "./../pages/Products/WindowTypes/WoodAlu";
import Accessories from "./../pages/Products/Accessories";
import LegalNotice from "../pages/LegalNotice";
import NotFound from "../pages/NotFound";

const AppRoutes = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path={`/`} element={<Home />} />
        <Route path={`/about`} element={<About />} />
        <Route path={`/products`} element={<Products />} />
        <Route path={`/products/windows`} element={<Windows />} />
        <Route path={`/products/windows/wooden`} element={<Wooden />} />
        <Route path={`/products/windows/wood-alu`} element={<WoodAlu />} />
        <Route path={`/products/windows/passive`} element={<Passive />} />
        <Route path={`/products/entrance-doors`} element={<EntranceDoors />} />
        <Route path={`/products/interior-doors`} element={<InteriorDoors />} />
        <Route path={`/products/sliding-doors`} element={<SlidingDoors />} />
        <Route path={`/products/winter-garden`} element={<WinterGarden />} />
        <Route path={`/products/accessories`} element={<Accessories />} />
        <Route path={`/portfolio`} element={<Portfolio />} />
        <Route path={`/contact`} element={<Contact />} />
        <Route path={`/legal-notice`} element={<LegalNotice />} />

        {/* 404 - Not Found oldal */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
};

export default AppRoutes;
